import React, { useEffect, useState } from 'react'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import PropTypes from 'prop-types'
import { noop } from 'jquery'
import { getMobileOS, notify } from '../../utils/helper'
import { errorMessage } from '../../constants/errorMessage'
import { connect } from 'react-redux'

const DatatransWallet = (props) => {
    const {faciltyData, getValues, onSubmit, setIsSubmittingForm} = props
    const [os, setOs] = useState('Other')

    useEffect(() => {
        window.PaymentButton.on('abort', function () {
            // notify('error', 'Payment aborted')
        })
        handlePay(faciltyData)
    }, [EMPTY_ARRAY, faciltyData])

    useEffect(() => {
        const os = getMobileOS()
        setOs(os)
    }, [EMPTY_ARRAY])

    const handlePay = (ratesData) => {
        // window.open('https://pay.sandbox.datatrans.com/v1/start/231016152011938665', '_self')
        // const paymentPayload = {
        //     amount: ratesData?.payable_amount ? ratesData?.payable_amount : '0',
        //     paymentMethods: os == 'iOS' ? 'APL' : 'PAY',
        //     // paymentMethods: 'PAY',
        //     facility_id: faciltyData?.facility?.id,
        //     device_type: 'web'
        // }
        // Noneed to call this API as Payment butoon has auth function to generate the transaction id
        // dispatch(getTransactionId(paymentPayload)).then((res) => {
        setIsSubmittingForm(false)
        // setIsFetchRates(false)
        // window.open(`https://pay.sandbox.datatrans.com/v1/start/${res?.data?.transactionId}`, '_self')
        // window.open('https://pay.sandbox.datatrans.com/v1/start/231017142013921740', '_self')
        const payment = {
            // W3C spec
            details: {
                total: {
                    label: ratesData?.facility?.facility_payment_details?.data_trans_merchant_name,
                    amount: { value: ratesData?.payable_amount ? ratesData?.payable_amount : '0', currency: 'USD' },
                },
                displayItems: [
                    {
                        label: 'Tax',
                        amount: { value: '0', currency: 'USD' },
                    },
                ],
            },
            // W3C spec
            options: {
                requestPayerEmail: false,
                requestPayerName: false,
                requestPayerPhone: false,
            },
            // Datatrans specific
            transaction: {
                countryCode: 'US',
                refno: '123123',
            },
        }
    
        window.PaymentButton.init({
            merchantId: ratesData?.facility?.facility_payment_details?.data_trans_username_web,
            merchantName: ratesData?.facility?.facility_payment_details?.data_trans_merchant_name,
            tokenOnly: false,
            autoSettle: false,
            allowedCardNetworks: ['AMEX', 'DISCOVER', 'MASTERCARD', 'VISA'],
            googlePayConfiguration: {
                buttonType: 'long',
                buttonStyle: 'black',
                merchantId: ratesData?.facility?.facility_payment_details?.data_trans_gpay_merchant
            },
            applePayConfiguration: {
                buttonType: 'plain',
                buttonStyle: 'black'
            },
        })
        window.PaymentButton.on('init', function () {
            window.PaymentButton.create(document.getElementById('paybutton'), payment)
        })
    
        // handle transaction result
        window.PaymentButton.on('authorization', function (response) {
            const formData = getValues()
            const finalData = {...formData, walletPay : response, transaction_id: response?.transactionId}
            finalData.paymentMethod = os == 'iOS' ? 'APL' : 'PAY'
            onSubmit(finalData)
        })
    
        window.PaymentButton.on('error', function (err) {
            notify('error', err?.error?.message ? err?.error?.message : errorMessage?.somethingWentWrong)
        })
    
        window.PaymentButton.on('unsupported', function () {
            notify('error', 'Payment method not supported')
    
        })
        window.PaymentButton.on('abort', function () {
            notify('error', 'Payment aborted')
        })
    
        // handle transaction result
    
        // }).catch(() => {
        //     setIsSubmittingForm(false)
        //     // setIsFetchRates(false)
        // })
    
    }
    


    return (
        <div className='px-2' id='paybutton'></div>
    )
}
DatatransWallet.propTypes = {
    dispatch: PropTypes.func,
    faciltyData: PropTypes.object, 
    getValues: PropTypes.func, 
    onSubmit: PropTypes.func,
    setIsSubmittingForm: PropTypes.func,
}

DatatransWallet.defaulProps = {
    dispatch: noop,
    faciltyData: EMPTY_OBJECT,
    getValues: noop, 
    onSubmit: noop,
    setIsSubmittingForm: noop,
}
function mapStateToProps({ PaymentReducer }) {
    return {
        loader: PaymentReducer?.loader
    }
}
export default connect(mapStateToProps)(DatatransWallet)
